import { render, staticRenderFns } from "./package-ticket.vue?vue&type=template&id=1659c06e&scoped=true&"
import script from "./package-ticket.vue?vue&type=script&lang=js&"
export * from "./package-ticket.vue?vue&type=script&lang=js&"
import style0 from "./package-ticket.vue?vue&type=style&index=0&id=1659c06e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1659c06e",
  null
  
)

export default component.exports